import * as React from 'react';
import classnames from 'classnames';
import styles from './icons.scss';

function TemplateIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={classnames(styles.icons, props.className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3.25a.75.75 0 00-.75.75v16c0 .414.336.75.75.75h12a.75.75 0 00.75-.75V8a.75.75 0 00-.22-.53l-2-2-2-2a.75.75 0 00-.53-.22H6zm.75 16V4.75h5.5V8c0 .966.784 1.75 1.75 1.75h3.25v9.5H6.75zm10.44-11l-1.72-1.72-1.72-1.72V8c0 .138.112.25.25.25h3.19z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11a1 1 0 100 2h1v3a1 1 0 102 0v-3h1a1 1 0 100-2h-4z" />
    </svg>
  );
}
export default React.memo(TemplateIcon);
